//HACK: Use proper imports once the main workspace (`ulule`) uses date-fns v2
//@ts-expect-error: the export is not typed,  but the previous lines provides
//the correct types
export * from '../../../node_modules/date-fns/index'
